<template>
  <BreadCrumb :PageTitle="t('breadCrumb.myDirectory')" />
  <ContactsContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";

//import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ContactsContent from "../../components/CRM/Leads/ContactsContent.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ContactsPage",
  components: {
   // BreadCrumb,
    ContactsContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>